<template>
    <div class="existing-group-row">
        <span>How many: &nbsp</span>
        <el-select
                placeholder="Select"
                :value="type"
                @change="handleUpdateType"
        >
            <el-option
                    v-for=" option in typeOptions
        "
                    :key="option.value"
                    :label="option.label"
                    :value="option.value"
            >
            </el-option>
        </el-select>
        <span>
                &nbsp are in a {{depth === 0 ? 'carton' : 'package'}}? &nbsp
        </span>
        <el-input-number
                style="margin-right: 10px"
                :controls="false"
                :value="quantity"
                @change="handleUpdateQuantity"
        ></el-input-number>
    </div>
</template>

<script>
    export default {
        props: {
            type: String,
            quantity: String | Number,
            depth: String | Number
        },
        data: () => ({
            typeOptions: [
                {
                    value: "UNIT",
                    label: "Units"
                },
                {
                    value: "PACKAGE",
                    label: "Packages"
                }
            ]
        }),
        methods: {
            handleUpdateType(newType) {
                this.emitUpdateGroupEvent({
                    type: newType,
                    quantity: this.quantity,
                    depth: this.depth
                });
            },

            handleUpdateQuantity(newQuantity) {
                this.emitUpdateGroupEvent({
                    type: this.type,
                    quantity: newQuantity,
                    depth: this.depth
                });
            },

            emitUpdateGroupEvent(updatedGroup) {
                const prevGroup = {
                    type: this.type,
                    quantity: this.quantity,
                    depth: this.depth
                };

                this.$emit('update:group', updatedGroup, prevGroup);
            }
        }
    }
</script>

<style scoped lang="scss">
    @import '~@/styles/variables';

    .existing-group-row {
        display       : flex;
        align-items   : center;
        margin-bottom : 20px;
    }
</style>